<template>
  <custom-plane>
    <div class="security-num">
      <div class="security-item">
        <div class="item-name">正常数量</div>
        <div class="item-num color1">0</div>
      </div>
      <div class="security-item">
        <div class="item-name">待机数量</div>
        <div class="item-num">0</div>
      </div>
      <div class="security-item">
        <div class="item-name">故障数量</div>
        <div class="item-num color2">0</div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.security-num {
  width: 416px;
  height: 172px;
  display: flex;
  padding: 40px 34px;
  justify-content: space-between;
  .security-item {
    height: 92px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-name {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #fff;
      margin-bottom: 10px;
    }
    .item-num {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 55px;
      font-size: 48px;
      line-height: 55px;
      font-family: "dina";
    }
  }
}
</style>
